import { AdminLayout } from "@opendash/core";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ManageKanbanStates } from "../../features/administration";

export const KanbanManagePage = observer(() => {
  return (
    <AdminLayout contentPadding>
      <ManageKanbanStates />
    </AdminLayout>
  );
});
